import React, { Fragment, useRef } from "react";
import _ from "lodash";

import RegisterFields from "./RegisterFields";
import equipmentFields from "./equipmentFields";

export const EquipmentForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(
      equipmentFields,
      ({ label, name, type, options, required, disabled, description }) => {
        const initailValue = props.initailValues
          ? props.initailValues[name]
          : null;
        const fieldOptions =
          name === "deviceName" &&
          initailValue &&
          !options.includes(initailValue)
            ? [initailValue, ...options]
            : options;

        return (
          <RegisterFields
            key={name}
            name={name}
            label={label}
            type={type}
            value={inputRef.current.name}
            fileNames={props.fileNames}
            options={fieldOptions}
            required={required}
            initailValue={initailValue}
            onChange={props.onChange(name)}
            disabled={disabled}
            description={description}
            viewonly={props.viewonly}
          />
        );
      }
    );
  };

  return <Fragment>{renderFields()}</Fragment>;
};
